import { useEffect } from "react";

// https://stackoverflow.com/questions/23074748/important-inline-styles-in-react
export const vipStyle = (n, style) => {
  if (n) {
    for (const s in style) {
      n.style.setProperty(s, style[s], "important");
    }
  }
};

export const useOutsideClickDetection = (ref, onClickOutside) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
};

const maxSeoTextLength = 60;
export const getSeoText = (text) => {
  // Retirement Income One? -> requirement-income-one
  // Remove special chars
  // Replace space by dash
  // Convert to lower case
  let clean = text
    .replace(/[^\w\s]/gi, "")
    .replace(/ /g, "-")
    .toLowerCase();

  // Cut by max length
  // Cut by last exceeding word
  const words = clean.split("-");
  let result = "";

  let splitter = "";
  for (const word of words) {
    if ((result + splitter + word).length <= maxSeoTextLength) {
      result += splitter + word;
    } else {
      break;
    }
    splitter = "-";
  }
  return result.trim();
};
// let data = getSeoText("I am 55 years old but have not decided what to do with my CPF savings. Can I take out only when I need it?")
// console.log(data, data.length);

const PASSPORT_MIN_LENGTH = 4;
const PASSPORT_MAX_LENGTH = 15;
export const isValidPassport = (v) => {
  return v.length >= PASSPORT_MIN_LENGTH && v.length <= PASSPORT_MAX_LENGTH;
}

export const isValidCpfAccountNumber = (v) => {
  const re = /^[S,T][A,B,C,D,F]\d{6}[A-Z]$/i;
  return re.test(v);
}

export const isValidEmail = (v) => {
  // const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return re.test(v);
}

const OTP_LENGTH = 6;
export const isValidOTP = (v) => {
  return v.length === OTP_LENGTH;
}

// ref -> safe string
export const safeVal = (ref) => ref.current?.value.trim();

// export const scrollTo = (ref, adj) => window.scrollTo(0, ref.current.getBoundingClientRect().top + window.scrollY + adj);
